
























































import Header from '@/components/common/Header.vue';
import InfoBar from '@/components/common/InfoBar.vue';
import Menu from '@/components/common/Menu.vue';
import Loader from '@/components/common/Loader.vue';
import GoToPanelDialog from '@/components/activation/GoToPanelDialog.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { regionService } from '@/services/RegionService';
import VirtualMachinesListOperations from '@/components/virtual-machines-list/VirtualMachinesListOperations.vue';
import { storeService } from '@/services/StoreService';
import CardGoToPanelDialog from '@/components/activation/CardGoToPanelDialog.vue';
import NotFound from '@/components/common/NotFound.vue';

@Component({
  components: {
    NotFound,
    Header,
    InfoBar,
    Menu,
    Loader,
    GoToPanelDialog,
    CardGoToPanelDialog,
    VirtualMachinesListOperations,
  },
})
export default class Workspace extends Vue {
  workspaceId = 0;
  regionId = 0;
  regions = [];
  isAnyRegionActive = false;
  isIntroOpen = false;
  isCardActivated = false;
  currentRegion: any = {
    id: 0,
    name: 'No region selected',
    active: false,
  };
  isLoading = false;
  isLoadingPage = true;
  @Watch('$route.params.regionId')
  onRegionChange() {
    this.update();
  }
  @Watch('$route.fullPath')
  onPathChange() {
    this.update();
  }
  @Watch('$store.state.regions.regions', { immediate: true, deep: true })
  onRegionsChange() {
    this.regions = this.$store.state.regions.regions;
    this.currentRegion = this.$store.getters['regions/getCurrentRegion'];
    this.regions.forEach((region: any) => {
      if (region.active) {
        this.isAnyRegionActive = true;
      }
    });
  }

  mounted() {
    this.update();
    storeService.getRegions().then(() => {
      setTimeout(() => {
        this.isLoadingPage = false;
      }, 500);
    });
  }
  activate() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    regionService
      .activate(this.workspaceId, this.regionId)
      .then(() => {
        this.isLoading = false;
        this.update();
        this.$root.$emit('update-regions');
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  activateChoosenRegion(regionId: any) {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    regionService
      .activate(this.workspaceId, regionId)
      .then(() => {
        this.isLoading = false;
        this.$root.$emit('update-regions');
        this.$router.push(`/workspaces/${this.workspaceId}/regions/${regionId}`).catch(() => {});
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  private update() {
    this.isIntroOpen = this.$route.fullPath.indexOf('intro') !== -1;
    this.isCardActivated = this.$route.fullPath.indexOf('cardActivated') !== -1;
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
  }
}
